import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
    Calculator,
    FileDown,
    Loader2,
    MessageSquare,
    MoreHorizontal,
    Sparkles,
    Stethoscope,
} from "lucide-react";

function IconBtn({ title, onClick, disabled, busy, children, className = "" }) {
    return (
        <button
            type="button"
            title={title}
            onClick={onClick}
            disabled={disabled || busy}
            className={`h-7 w-7 rounded-md border border-white/10 bg-[#0B0F19]/80 hover:bg-white/10 flex items-center justify-center transition disabled:opacity-40 ${className}`}
        >
            {busy ? (
                <Loader2 className="h-3.5 w-3.5 animate-spin text-[#F3E5AB]" />
            ) : (
                children
            )}
        </button>
    );
}

export default function DegerKaybiRowActions({
    row,
    pdfBusy,
    waBusy,
    onPdf,
    onWhatsApp,
    onOgrenme,
}) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        if (!open) return undefined;
        const close = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", close);
        return () => document.removeEventListener("mousedown", close);
    }, [open]);

    return (
        <div className="inline-flex items-center gap-0.5" ref={ref}>
            <IconBtn
                title="Hesaplama PDF"
                onClick={(e) => {
                    e.stopPropagation();
                    onPdf(row);
                }}
                busy={pdfBusy}
                className="text-[#F3E5AB] border-[#D4AF37]/25 hover:bg-[#D4AF37]/10"
            >
                <FileDown className="h-3.5 w-3.5" />
            </IconBtn>
            <IconBtn
                title="WhatsApp hatırlat"
                onClick={(e) => {
                    e.stopPropagation();
                    onWhatsApp(row);
                }}
                busy={waBusy}
                className="text-emerald-300 border-emerald-500/20 hover:bg-emerald-500/10"
            >
                <MessageSquare className="h-3.5 w-3.5" />
            </IconBtn>
            <div className="relative">
                <IconBtn
                    title="Diğer işlemler"
                    onClick={(e) => {
                        e.stopPropagation();
                        setOpen((v) => !v);
                    }}
                    className="text-slate-300"
                >
                    <MoreHorizontal className="h-3.5 w-3.5" />
                </IconBtn>
                {open && (
                    <div
                        className="absolute right-0 top-full mt-1 z-20 min-w-[11rem] rounded-lg border border-white/10 bg-[#0B0F19] py-1 shadow-xl"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <Link
                            to={`/yeni/deger-kaybi-gelismis?dosya=${row.sigorta_dosyasi || row.sigorta_dosyasi_id || ""}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-2 px-3 py-2 text-xs text-slate-200 hover:bg-white/5"
                            onClick={() => setOpen(false)}
                        >
                            <Calculator className="h-3.5 w-3.5 text-violet-400" />
                            Gelişmiş DK
                        </Link>
                        <Link
                            to="/yeni/ekspertiz-hasar"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-2 px-3 py-2 text-xs text-slate-200 hover:bg-white/5"
                            onClick={() => setOpen(false)}
                        >
                            <Stethoscope className="h-3.5 w-3.5 text-sky-400" />
                            Hasar Uzmanı
                        </Link>
                        <button
                            type="button"
                            className="w-full flex items-center gap-2 px-3 py-2 text-xs text-slate-200 hover:bg-white/5 text-left"
                            onClick={() => {
                                setOpen(false);
                                onOgrenme(row);
                            }}
                        >
                            <Sparkles className="h-3.5 w-3.5 text-violet-400" />
                            Öğrenme kaydı
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}
